<template>
  <vs-popup :title="'Özellik Eşleştir ' + marketplace" :active.sync="popupActiveSiparis2Local" button-cancel="border"
    @cancel="clearFields" @close="clearFields" classContent="popup-example">
    <h5 class="text-primary"> {{ stockName }} - {{ stockCode }} - {{ stockBarcode }}</h5>
    <vs-card>
      <b-row>
        <b-col cols="5">
          <v-select v-model="categoryProperty" :options="kategoriOzellikListesi" label="attributeName" style="" solo
            @input="filterCategoryProp"></v-select>
        </b-col>
        <b-col cols="5">
          <v-select v-model="categorySubProperty" :options="kategoriAltOzellikleri" label="valueName" style=""
            solo></v-select>
        </b-col>
        <b-col cols="2">
          <b-button style="  border-color:white !important;" v-on:click="ozellikleriEsle()" id="loading-eslestir"
            class="bg-primary-gradient vs-con-loading__container">
            <Icon icon="lucide:merge" width="20" height="20" v-b-tooltip.hover.bottom="'Eşleştir'" />
          </b-button>
        </b-col>
      </b-row>
      <b-row>
        <ag-grid-vue style="width: 100%; height: 400px; margin-top: 25px" class="ag-theme-alpine"
          :defaultColDef="defaultColDef" :columnDefs="columnDefs" :rowData="propertiesMatchList" :localeText="localeText"
          @grid-ready="onGridReady">
        </ag-grid-vue>
      </b-row>
    </vs-card>

  </vs-popup>
</template>
<script>
import { Icon } from "@iconify/vue2";
import StockPropertiesButonsCellRenderer from "./CellRenderers/StockPropertiesButonsCellRenderer.vue"
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import state from "../../store/state";
import Store from "../../store/store";
import vSelect from "vue-select";
export default {
  components: { "v-select": vSelect, AgGridVue, Icon, StockPropertiesButonsCellRenderer },
  props: {
    popupActiveSiparis2Popup: {
      type: Boolean,
      required: true
    },
    marketplace: {
      type: String,
      default: "",
    },
    categoryId: {
      type: String,
      default: "",
    },
    stockData: {
      default: () => { }
    }
  },
  watch: {
    popupActiveSiparis2Popup(val) { 
      if (val == true && this.stockData) {
        this.kategoriOzellikleri(this.marketplace, this.categoryId);
        this.stockName = this.stockData.StokAdi
        this.stockCode = this.stockData.STOK_KODU
        this.stockBarcode = this.stockData.Barkod
      }

      return val
    }
  },
  data() {
    return {
      stockName: "",
      stockCode: "",
      stockBarcode: "",
      defaultColDef: {
        sortable: true,
        resizable: true
      },
      columnDefs: null,
      localeText: null,
      ozellikEsleListeFlag: false,
      categoryProperty: "",
      categorySubProperty: "",
      kategoriOzellikListesi: [],
      kategoriAltOzellikleri: [],
      ozellikOzellikleri: [],
      propertiesMatchList: []
    };
  },
  mounted() {
    this.$root.$on("deleteProperty", (data) => {
      this.deleteProperty(data);
    });

  },
  beforeDestroy() {
    this.$root.$off("deleteProperty");

  },
  computed: {
    popupActiveSiparis2Local: {
      get() {
        return this.popupActiveSiparis2Popup
      },
      set(val) {
        if (!val) {
          this.$emit('closeSidebar')
          // this.$validator.reset()
          // this.initValues()
        }
      }
    },
  },

  methods: {
    ozellikleriEsle() {
      var vm = this;
      var vs = this.$vs;

      const soap = require("soap");
      const url = state.sistemAddress;
      var ozellikleriEsleargs = {
        program: vm.marketplace,
        token: Store.state.tokenId,
        stokKodu: vm.stockCode,
        barkod: vm.stockBarcode,
        muhasebeAlan: vm.categoryProperty.attributeName,

        ozellikId: vm.categoryProperty.attributeid,
        alanDegeri: vm.categorySubProperty.valueName,
        kontrol: 1,
        manuel: 1,
        ozellikAltId: vm.categorySubProperty.valueId,
      };
      /*   if (this.ozellikEsleListeFlag == true) {
           ozellikleriEsleargs = {
             program: vm.aktifPazaryeri,
             token: Store.state.tokenId,
             stokKodu: this.ozellikEsleListeStokKodu,
             barkod: this.ozellikEsleListeBarkod,
             muhasebeAlan: vm.categoryProperty.attributeName,
   
             ozellikId: vm.categoryProperty.attributeid,
             alanDegeri: vm.categorySubProperty.valueName,
             kontrol: 1,
             manuel: 1,
             ozellikAltId: vm.categorySubProperty.valueId,
           };
         }*/ 
      soap.createClient(url, function (err, client) {
        client.ozellikleriEsleManuel(
          ozellikleriEsleargs,
          function (err, result) {
            if (result.ozellikleriEsleManuelResult == "-1") {
              Store.dispatch("logout");
            }
            try {
              vm.veriler = JSON.parse(result.ozellikleriEsleManuelResult);
              if (vm.veriler.response == "Ok") {
                vm.ozellikEslemeListesi(vm.marketplace.trim());
              } else {
                vs.notify({
                  title: "Stok detayı",
                  text: result,
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "danger",
                  position: "top-center"
                });
              }


            } catch (error) {
              vs.notify({
                title: "Stok detayı",
                text: error,
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
                position: "top-center"
              });
            }
          }
        );
      });
    },
    deleteProperty(id) {
      var vm = this;
      var vs = this.$vs;

      const soap = require("soap");
      const url = state.sistemAddress;

      const args = {
        id: id,
        pazaryeri: vm.marketplace.trim(),
        barkod: vm.stockBarcode.trim(),
        token: Store.state.tokenId,
      };
 
      soap.createClient(url, function (err, client) {
        client.eslesenStokOzellikleriListesiSil(args, function (err, result) {
          if (result.eslesenStokOzellikleriListesiSilResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            if (result.eslesenStokOzellikleriListesiSilResult == "Ok") {
              vm.ozellikEslemeListesi(vm.marketplace.trim());
            } else {
              vs.notify({
                title: "Stok detayı",
                text: result.eslesenStokOzellikleriListesiSilResult,
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
                position: "top-center"
              });
            }


          } catch (error) {
            vs.notify({
              title: "Stok detayı",
              text: error,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center"
            });
          }


        });
      });
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
    },
    clearFields() {
      this.$root.$emit("closeCategoryProperties");
    },
    indexbul(array, conditionFn) {
      const item = array.find(conditionFn);
      return array.indexOf(item);
    },
    filterCategoryProp() {
      this.kategoriAltOzellikleri = this.ozellikOzellikleri.filter(
        (d) => d.attributeid === this.categoryProperty.attributeid
      );
    },
    kategoriOzellikleri(pazaryeri, KategoriIdd) {
      this.suggestPazaryer = pazaryeri;
      this.suggestKategoriId = KategoriIdd;
      this.datasuggest = [];
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        pazaryeri: pazaryeri,
        token: Store.state.tokenId,
        categoryId: KategoriIdd,
      };
      soap.createClient(url, function (err, client) {
        client.pazaryeriKategoriOzellik(args, function (err, result) {
          if (result.pazaryeriKategoriOzellikResult == "-1") {
            Store.dispatch("logout");
          }
          vm.veriler = JSON.parse(result.pazaryeriKategoriOzellikResult);
          vm.kategoriSuz = vm.veriler["json"];
          let ozellikler = vm.veriler["json"];
          vm.ozellikOzellikleri = ozellikler;
          const kategoriOzellik = [
            ...new Set(ozellikler.map((x) => x.attributeid)),
          ];
          vm.kategoriOzellikListesi = [];
          for (let s = 0; s < kategoriOzellik.length; s++) {
            vm.indext = vm.indexbul(
              vm.kategoriSuz,
              (item) => item.attributeid === kategoriOzellik[s]
            );
            vm.kategoriOzellikListesi.push({
              attributeName:
                vm.kategoriSuz[parseInt(vm.indext)]["attributeName"],
              attributeid: vm.kategoriSuz[parseInt(vm.indext)]["attributeid"],
            });
          }
          vm.datasuggest = vm.kategoriOzellikListesi;

          vm.ozellikEslemeListesi(pazaryeri);
        });
      });
    },

    ozellikEslemeListesi(pazaryeri) {
      var vm = this;
      var vs = this.$vs;

      const soap = require("soap");
      const url = state.sistemAddress;
      var listEslesenArgs = {};

      listEslesenArgs = {
        program: pazaryeri,
        token: Store.state.tokenId,
        barkod: vm.stockData.Barkod,
      };
      /*  if (vm.ozellikEsleListeFlag == true) {
          listEslesenArgs = {
            program: pazaryeri,
            token: Store.state.tokenId,
            barkod: vm.ozellikEsleListeBarkod,
          };
        }*/
      soap.createClient(url, function (err, client) {
        client.eslesenStokOzellikleriListesi(
          listEslesenArgs,
          function (err, result) {
            if (result.eslesenStokOzellikleriListesiResult == "-1") {
              Store.dispatch("logout");
            }
            try {
              vm.veriler = JSON.parse(result.eslesenStokOzellikleriListesiResult);
              vm.propertiesMatchList = vm.veriler;
              vm.columnDefs = [];
              let list = vm.propertiesMatchList;
              let columnList = Object.keys(list[0]); 
              vm.columnDefs.push({
                width: 100,
                pinned: "left",
                filter: "agSetColumnFilter",
                cellRenderer: "StockPropertiesButonsCellRenderer"
              });
              columnList.forEach((val, index) => {
                if (val.includes("id") || val.includes("Id") || val.includes("program") || val.includes("stokKodu") || val.includes("barkod")) {
                  vm.columnDefs.push({
                    field: val,
                    filter: "agSetColumnFilter",
                    hide: true
                  });
                }
                else
                  vm.columnDefs.push({
                    field: val,
                    filter: "agSetColumnFilter"
                  });
              })

            } catch (error) {
              vs.notify({
                title: "Stok detayı",
                text: error,
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
                position: "top-center"
              });
            }


          }
        );
      });
    },

  },
  created() {
    this.localeText = this.$store.state.uzum.AG_GRID_LOCALE_EN;
  }
};
</script>